<template>
  <div class="step1">
    <van-nav-bar
      title="带货权限申请"
      left-arrow
      fixed
      placeholder
      @click-left="$router.go(-1)"
    />
    <div class="main">
      <p class="title">申请要求</p>
      <div class="requirements">
        <div class="row" v-for="(item, idx) in requirements" :key="idx">
          <el-image class="icon" :src="item.icon" fit="cover"></el-image>
          <span class="name">{{ item.name }}</span>
          <div class="right">
            <span class="status" v-if="idx == 2 || idx == 3">已满足</span>
            <div v-else>
              <template v-if="idx == 0">
                <span class="status" v-if="form.isAuthentication">已认证</span>
                <p
                  v-else
                  class="r-btn"
                  @click="
                    $router.push('/simulation/douyinchuchuang/authentication')
                  "
                >
                  认证
                </p>
              </template>
              <template v-else>
                <span v-if="form.isBond" class="status">已充值</span>
                <p v-else class="r-btn" @click="handleRecharge">去充值</p>
              </template>
            </div>
          </div>
        </div>
      </div>
      <p class="title">获得权益</p>
      <p class="tips">申请成功后可在商品橱窗、短视频、直播中添加精选联盟商品</p>
      <p class="tips">
        可登录电商PC工作条（巨量百应）进行橱窗管理、推广数据查看、直播间中控等操作
      </p>
    </div>
    <div class="bottom" style="border-top: solid 1px #dcdfe6">
      <div v-if="form.isAuthentication">
        <van-checkbox
          v-model="follow"
          checked-color="#ee0a24"
          icon-size="16px"
          style="margin-bottom: 10px; font-size: 12px"
        >
          关注@电商小助手，了解更多功能和权益
        </van-checkbox>
        <van-checkbox
          v-model="agree"
          checked-color="#ee0a24"
          icon-size="16px"
          style="margin-bottom: 10px; font-size: 12px"
          >已阅读并同意<span style="color: #3235dd"
            >《商品分享协议》《精选联盟协议及隐私政策》《巨量百应平台协议及隐私政策》</span
          ></van-checkbox
        >
      </div>
      <div class="btn" :class="{ disabled }" @click="onClick">立即申请</div>
    </div>
  </div>
</template>

<script>
import "vant/lib/index.css";
import { NavBar, Toast, Checkbox } from "vant";
export default {
  components: {
    [NavBar.name]: NavBar,
    [Toast.name]: Toast,
    [Checkbox.name]: Checkbox,
  },
  props: {
    form: Object,
  },
  data() {
    return {
      requirements: [
        {
          icon: require("@/assets/images/simulation/icon_sm.png"),
          name: "实名认证",
        },
        {
          icon: require("@/assets/images/simulation/icon_bzj.png"),
          name: "作者保证金￥500",
        },
        {
          icon: require("@/assets/images/simulation/icon_sp.png"),
          name: "个人主页视频≥10条",
        },
        {
          icon: require("@/assets/images/simulation/icon_fs.png"),
          name: "抖音账号粉丝量≥1000",
        },
      ],
      follow: true,
      agree: false,
    };
  },
  computed: {
    disabled() {
      return !this.form.isAuthentication || !this.form.isBond || !this.agree;
    },
  },
  methods: {
    handleRecharge() {
      if (!this.form.isAuthentication) Toast("请先进行实名认证");
      else {
        Toast("充值成功");
        this.form.isBond = true;
      }
    },
    onClick() {
      if (!this.disabled) this.$router.go(-1);
    },
  },
};
</script>

<style lang="less" scoped>
.step1 {
  .main {
    padding: 0 15px;
    .title {
      padding: 15px 0;
      font-weight: bold;
    }
    .requirements {
      padding: 0 10px;
      background-color: #fff;
      .row {
        position: relative;
        padding: 10px 0;
        border-bottom: solid 1px #e4e7ed;
        .icon {
          vertical-align: middle;
        }
        .name {
          display: inline-block;
          margin-left: 10px;
          font-weight: bold;
          vertical-align: middle;
        }
        .right {
          position: absolute;
          top: 50%;
          right: 0;
          transform: translateY(-50%);
          .status {
            padding: 0 20px;
            color: #909399;
          }
          .r-btn {
            padding: 5px 20px;
            min-width: 82px;
            text-align: center;
            color: #fff;
            background-color: #e21e48;
            border-radius: 3px;
            cursor: pointer;
          }
        }
      }
    }
    .tips {
      position: relative;
      padding-left: 15px;
      margin-bottom: 15px;
      line-height: 1.5;
      font-size: 13px;
      &::before {
        content: "";
        position: absolute;
        left: 0;
        top: 6px;
        width: 5px;
        height: 5px;
        border-radius: 50%;
        background-color: #000;
      }
    }
  }
  .bottom {
    position: fixed;
    bottom: 0;
    padding: 10px;
    width: 100%;
    background-color: #f2f6fc;
    box-shadow: 0 -8px 12px #f2f6fc;
    .btn {
      padding: 10px 0;
      text-align: center;
      color: #fff;
      background-color: #e21e48;
      border-radius: 3px;
      user-select: none;
      cursor: pointer;
      &.disabled {
        opacity: 0.4;
        cursor: not-allowed;
      }
    }
  }
}
</style>